function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.82579 22C8.56663 22 10.7885 19.7614 10.7885 17C10.7885 14.2386 8.56663 12 5.82579 12C3.08496 12 0.863068 14.2386 0.863068 17C0.863068 19.7614 3.08496 22 5.82579 22Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7286 22C21.4695 22 23.6914 19.7614 23.6914 17C23.6914 14.2386 21.4695 12 18.7286 12C15.9878 12 13.7659 14.2386 13.7659 17C13.7659 19.7614 15.9878 22 18.7286 22Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.6315 22C34.3723 22 36.5942 19.7614 36.5942 17C36.5942 14.2386 34.3723 12 31.6315 12C28.8906 12 26.6688 14.2386 26.6688 17C26.6688 19.7614 28.8906 22 31.6315 22Z",
  fill: "currentColor"
});

var SvgOther = function SvgOther(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOther, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Other.aacc5719.svg";
export { ForwardRef as ReactComponent };